<template>
  <div class="fullscreen-welcome-container">
    <div
      class="fullscreen-welcome-message"
      :class="{
        'message-enter': welcomeAnimationState === 'entering',
        'message-leave': welcomeAnimationState === 'leaving'
      }"
      :style="welcomeMessageStyle"
    >
      <div class="welcome-text-content">{{ welcomeMessage }}</div>
    </div>
  </div>
</template>

<script>
import screenLifecycleMixin from '@/utils/screenLifecycleMixin';

export default {
  mixins: [screenLifecycleMixin],
  name: 'SleepViewFullscreenWelcome',
  props: {
    welcomeMessage: {
      type: String,
      default: ''
    },
    welcomeAnimationState: {
      type: String,
      default: ''
    },
    welcomeMessageStyle: {
      type: Object,
      default: () => ({})
    }
  }
};
</script>

<style scoped>
.fullscreen-welcome-container {
  width: 100%;
  height: 100%;
  background-image: url('@/assets/bg.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  overflow: hidden;
}

.fullscreen-welcome-message {
  text-align: center;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  padding: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  transform: translateY(0);
  transition: all 0.3s ease-in-out;
  font-size: var(--welcome-font-size, 36px);
  line-height: 1.4;
  overflow: visible;
  max-width: 90%;
  max-height: 90%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-text-content {
  word-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow-wrap: break-word;
  width: 100%;
  font-size: inherit;
}

/* 全屏欢迎语进入动画 */
.fullscreen-welcome-message.message-enter {
  animation: fullscreenMessageSlideIn 0.6s ease-out both;
}

/* 全屏欢迎语退出动画 */
.fullscreen-welcome-message.message-leave {
  animation: fullscreenMessageSlideOut 0.5s ease-in both;
}

@keyframes fullscreenMessageSlideIn {
  0% {
    transform: translateY(-50px) scale(0.9);
    opacity: 0;
  }
  100% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}

@keyframes fullscreenMessageSlideOut {
  0% {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(50px) scale(0.9);
    opacity: 0;
  }
}
</style>
